import instance from '../api/interceptor';

export const AiService = {
  async processImage(data) {
    return instance.post('/ai/food', data);
  },

  async newBody(data) {
    return instance.post('/ai/new-body', data);
  },

  async faceLandmarks(file) {
    const formData = new FormData();
    formData.append('image', file);
    return instance.post('/ai/face-landmarks', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};
